import React from 'react';
import {
  offset,
  flip,
  shift,
  arrow,
  autoUpdate,
  useFloating,
  useInteractions,
  useFocus,
  useRole,
  useDismiss,
  useClick,
} from '@floating-ui/react-dom-interactions';

export const Dropdown = ({
  children,
  render,
  open,
  setOpen,
  placement: passedPlacement = 'top',
  offset: passedOffset = 5,
  shift: shiftPassed = { padding: 8 },
  arrow: arrowSettings,
}) => {
  const middleware = [offset(passedOffset), flip(), shift(shiftPassed)];

  if (arrowSettings) {
    middleware.push(arrow(arrowSettings));
  }

  const {
    x,
    y,
    reference,
    floating,
    strategy,
    placement,
    context,
    middlewareData,
  } = useFloating({
    placement: passedPlacement,
    open,
    onOpenChange: setOpen,
    middleware,
    whileElementsMounted: autoUpdate,
  });

  const { getReferenceProps, getFloatingProps } = useInteractions([
    useFocus(context),
    useClick(context),
    useRole(context, { role: 'tooltip' }),
    useDismiss(context),
  ]);

  return (
    <>
      <div {...getReferenceProps({ ref: reference, ...children.props })}>
        {children}
      </div>
      {open && (
        <div
          {...getFloatingProps({
            ref: floating,
            style: {
              position: strategy,
              top: y ?? '',
              left: x ?? '',
              zIndex: 3,
            },
          })}
        >
          {render({ middlewareData, placement })}
        </div>
      )}
    </>
  );
};
